import Vue from "vue";
import home from './Home.vue';

let typePage = /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent) ? 'm' : 'images';
if(typePage === 'm'){
  import('./assets/scss/home-m-css.scss')
} else {
  import('./assets/scss/home-pc-css.scss')
}

Vue.config.productionTip = false;
Vue.prototype.$typePage = typePage;

new Vue({
    render: (h) => h(home),
  }).$mount('#home');